/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { InfomationsModel } from "../models";
import { SortDirection } from "@aws-amplify/datastore";
import { getOverrideProps, useDataStoreBinding } from "./utils";
import DataLineLow from "./DataLineLow";
import { Collection } from "@aws-amplify/ui-react";
export default function DataLineLowCollection(props) {
  const { items: itemsProp, setIsNewFlg, overrideItems, overrides, ...rest } = props;
  const itemsPagination = {
    sort: (s) => s.release_date(SortDirection.DESCENDING),
  };
  const [items, setItems] = React.useState(undefined);
  const itemsDataStore = useDataStoreBinding({
    type: "collection",
    model: InfomationsModel,
    pagination: itemsPagination,
  }).items;
  React.useEffect(() => {
    if (itemsProp !== undefined) {
      setItems(itemsProp);
      return;
    }
    setItems(itemsDataStore);
  }, [itemsProp, itemsDataStore]);
  return (
    <Collection
      type="list"
      isPaginated={true}
      searchPlaceholder="Search..."
      itemsPerPage={5}
      direction="column"
      justifyContent="stretch"
      items={items || []}
      {...getOverrideProps(overrides, "DataLineLowCollection")}
      {...rest}
    >
      {(item, index) => (
        <DataLineLow
          setIsNewFlg={setIsNewFlg}
          infomationsModel={item}
          key={item.id}
          {...(overrideItems && overrideItems({ item, index }))}
        ></DataLineLow>
      )}
    </Collection>
  );
}
